import { render, staticRenderFns } from "./AddPropertyInfo.vue?vue&type=template&id=0b946576&"
import script from "./AddPropertyInfo.vue?vue&type=script&lang=js&"
export * from "./AddPropertyInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports